
        export default {
          mounted() {
            this.el.showModal()

            // Escape und der Klick daneben schliessen das native Element — der
            // Server weiss davon nichts, bis es ihm jemand sagt. Sonst bliebe
            // `@tucking` stehen und die Frage kaeme beim naechsten Render zurueck.
            this.onClose = () => this.pushEvent("close_menu")
            this.el.addEventListener("close", this.onClose)

            // Ein Klick auf den Backdrop trifft das <dialog> selbst; der Inhalt
            // liegt im Kind darunter.
            this.onClick = (e) => { if (e.target === this.el) this.el.close() }
            this.el.addEventListener("click", this.onClick)
          },

          destroyed() {
            this.el.removeEventListener("close", this.onClose)
            this.el.removeEventListener("click", this.onClick)
          }
        }
      